import { render, staticRenderFns } from "./LiberarAcessoFrentista.vue?vue&type=template&id=2da79654&"
import script from "./LiberarAcessoFrentista.vue?vue&type=script&lang=js&"
export * from "./LiberarAcessoFrentista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports